/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import InfiniteScroll from 'react-infinite-scroller';

import { Button, Container, Icon, Loader, Message } from 'semantic-ui-react';

import classNames from 'classnames';

import '../../css/StudentAssignmentModal.less';

import { SatCoreComponent, SatCoreRegister } from '../../SatCoreRegistry';

import { CONTENT_MODE } from '../../managers/ContentManager';

import ImageService from '../../services/ImageService';
import ResourcePacingService from '../../services/ResourcePacingService';

import Modal from '../Modal';

export default @inject('classroomManager', 'courseManager', 'assignmentManager')
@observer
class StudentAssignmentModal extends Component {
  state = {
    isLoading: false
  }

  constructor(props) {
    super(props);
    this.ModalBanner = SatCoreComponent('ModalBanner');
    this.DeprecatedStudentAssignmentCard = SatCoreComponent('DeprecatedStudentAssignmentCard');
  }

  closeStudentAssignmentModal = () => {
    this.props.closeStudentAssignmentModal();
  }

  renderAssignmentCards = (assignments) => {
    const { handlePresent } = this.props;
    const { DeprecatedStudentAssignmentCard } = this;
    const components = [];
    assignments.map((assignment) => {
      const contentImageUrl = ImageService.getImageUrl(assignment);
      components.push(
        <DeprecatedStudentAssignmentCard
          key={`AAC_${assignment.id}`}
          assignment={assignment}
          {...this.props}
          contentImageUrl={contentImageUrl}
          handlePresent={handlePresent}
          hideTryAgain={true} />
        // TODO remove
        // fetchCourseActivityInformation={(assignment) => fetchCourseActivityInformation(
        //   assignment, assignmentElement, contentImageUrl
        // )}
        // handleAnswerKey={handleAnswerKey}
        // handleEditAssignment={(assignment, contentImageUrl) => handleEditAssignment(
        //   assignment, contentImageUrl, currentClassroomId, assignmentElement
        // )}
        // handleGradebook={handleGradebook}
      );
      return true;
    });
    return components;
  }

  handleLoadMore = async (page) => {
    const { assignmentManager, currentClassroomId, courseContentItemId, courseElement } = this.props;

    if (this.props.classeslist === null || this.props.classeslist === undefined) {
      const entityId = (this.props.assignmentElement) ? this.props.assignmentElement.entityId : courseElement.contentItemId;
      const currentCourseContentItemId = courseContentItemId || (courseElement.hasActivities ? courseElement.studentActivities[0].courseContentItemId : null);
      const courseResourceElementId = courseElement.hasActivities ? courseElement.studentActivities[0].courseResourceElementId : null;
      await assignmentManager.fetchContentAssignments(currentCourseContentItemId, courseResourceElementId, currentClassroomId, entityId, page);
    }
  }

  handleSelfPacedOpen = async (contentMode, contentElement) => {
    const { assignmentManager, classroomManager, courseManager } = this.props;
    // This takes a bit with the assignment and then the assess launch so show loader.
    this.setState({ isLoading: true });
    // first, create the assignment
    const success = await AssignmentService.createStudentPacedAssignment(contentElement.contentItemId, contentElement.elementId, classroomManager.currentClassroomId, courseManager.currentCourseId);
    // then call to open it.
    if (success && assignmentManager.getLastAddedAssignment()) {
      const assignment = assignmentManager.getLastAddedAssignment();
      const params = { assignment, contentMode };
      this.handleAssignmentViewPresent(params);
    } else {
      this.setState({ isLoading: false });
    }
  }

  handleAssignmentViewPresent = async (params) => {
    if (params.assignment) {
      const { handlePresent } = this.props;
      await handlePresent(params);
      this.setState({ isLoading: false });
    }
  }

  render() {
    const {
      assignmentManager,
      contentAssignmentsOpen,
      contentName,
      courseElement,
      fromStudentCourseDrivenAssignments,
      labelInfo,
      t
    } = this.props;
    const { props, state } = this;

    let label = `${t('assignmentInfoLabel', 'Assignment Information: ')}`;
    if (labelInfo !== undefined && labelInfo !== '' && labelInfo !== null) {
      label = labelInfo;
    }
    const assignments = props.assignments || assignmentManager.assignmentArray || [];

    const numberOfAssignments = assignments.length;
    const startedAssignments = assignments.filter((activity) => activity.status === 'started');
    const hasStartedAssignments = (startedAssignments) ? startedAssignments.length > 0 : false;
    const attempts = (courseElement && courseElement.attempts) ? ResourcePacingService.attempts(courseElement) : 0;
    const attemptsRemaining = (attempts > numberOfAssignments) ? attempts - numberOfAssignments : 0;
    const { ModalBanner } = this;

    return (
      <>
        <Modal
          className={classNames('StudentAssignmentModal', {
            StudentCourseDrivenAssignmentModal: fromStudentCourseDrivenAssignments
          })}
          closeOnDimmerClick={false}
          closeOnEscape={true}
          onClose={this.closeStudentAssignmentModal}
          open={contentAssignmentsOpen}
          size='large'>
          <ModalBanner label={label} onClose={this.closeStudentAssignmentModal} title={contentName} />
          <Modal.Content scrolling>
            {courseElement.pacingMode === 'student_paced' && (
              <Message>
                <Message.Content>
                  <span>
                    {t('attemptsLeft')}&nbsp;
                    {attemptsRemaining}
                  </span>
                  <span>
                    {(!hasStartedAssignments && attemptsRemaining > 0) && (
                      <Button
                        className='leaf-button'
                        disabled={state.isLoading}
                        loading={state.isLoading}
                        onClick={() => this.handleSelfPacedOpen(CONTENT_MODE.ASSESS, courseElement)}
                        primary>
                        <Icon name='redo alternate' />
                        {t('tryAgain')}
                      </Button>
                    )}
                  </span>
                </Message.Content>
              </Message>
            )}
            <Container fluid>
              {state.isLoading && !assignments.length && <Loader active />}
              {(!state.isLoading && !!assignments.length) ? (
                <div className='ui items parent'>
                  <InfiniteScroll
                    className='ui items scroller'
                    hasMore={typeof props.hasMore === 'boolean' ? props.hasMore : assignmentManager.hasMore}
                    loadMore={typeof props.loadMore === 'function' ? props.loadMore : this.handleLoadMore}
                    loader={<Loader key={0} active inline />}
                    pageStart={0}
                    threshold={50}>
                    {this.renderAssignmentCards(assignments)}
                  </InfiniteScroll>
                </div>
              ) : <>{t('noAssignmentsFound')}</>}
            </Container>
          </Modal.Content>

          <Modal.Actions>
            <Button basic className='cancelButton' onClick={this.closeStudentAssignmentModal} primary>
              {t('close')}
            </Button>
          </Modal.Actions>

        </Modal>

      </>
    );
  }
}

SatCoreRegister('StudentAssignmentModal', StudentAssignmentModal);
